<template>
    <div class="total-done" @keyup="keypressEvent">
        <pop-form class="form-box" v-if="isShow" width="580px" body-max-height="350px">
            <template slot="title">
                <i class="el-icon-back back" v-if="showBack" @click="cancel"></i>
                {{title}}
            </template>
            <div class="body-box">
                <!--第一步-->
                <el-form ref="form" :model="totalData" label-width="80px" v-if="step === 1">
                    <el-form-item label="应付">
                        <span class="red">¥ {{totalData.allTotalPrice}}</span>
                    </el-form-item>
                    <el-col :span="12">
                        <el-form-item label="实付">
                            <el-input v-model="totalData.actualMoney" :autofocus="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="付款方式">
                            <el-select v-model="payType.value" placeholder="请选择">
                                <el-option
                                        v-for="item in payType.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>

                <!--第二步-->
                <div class="over-box" v-if="step === 2">
                    <div class="success-icon"><i class="el-icon-success"></i></div>
                    <div class="total-price">¥ {{overData.totalPrice}}</div>
                    <div class="user-money">账户余额 {{storeUserMoney}}</div>
                    <div class="print-box">
                        <el-button plain @click="printState = true">打印小票</el-button>
                    </div>
                </div>
            </div>
            <template slot="foot">
                <div v-if="step === 1">
                    <el-button size="medium" @click="cancel">取消</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button size="medium" type="primary" @click="settleTotal">确定结算</el-button>
                </div>
                <div v-else-if="step === 2">
                    <el-button size="medium" type="primary" @click="settleAllOver">确定</el-button>
                </div>
            </template>
        </pop-form>

        <!--输入支付密码-->
        <el-dialog title="请输入会员支付密码" :visible.sync="showPayPassword" width="450px" append-to-body>
            <el-input v-model="totalData.pay_password" placeholder="请输入支付密码" type="password" :autofocus="true"
                      ref="passwordInput" @keyup.native="e => {if(e.code==='Enter') settlePost()}"
            ></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="settlePost">确 定</el-button>
            </span>
        </el-dialog>

        <!--小票打印-->
        <ticket-print v-model="printState" :ticket-data="ticketData"></ticket-print>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    import TicketPrint from "@/model/Cash/TicketPrint";
    export default {
        name: "TotalDone",
        components: {TicketPrint, PopForm},
        model: {
            prop: "isShow",
            event: "state",
        },
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            isBack: {
                type: Boolean,
                default: false
            },
            settleData: {
                type: Object,
                default: {}
            },
        },
        data: () => {
            return {
                step: 1,
                loading: false,
                showBack: false,
                title: "",
                totalData: {},
                payType: {
                    value: 4,
                    options: [
                        { label: "微信", value: 2},
                        { label: "支付宝", value: 3},
                        { label: "现金", value: 4},
                        { label: "银联卡", value: 5}
                    ]
                },
                showPayPassword: false,
                overData: {},

                //打印小票开关
                printState: false,
                ticketData: {},

                storeUserMoney: false
            };
        },
        mounted: function () {
            this.showBack = this.isBack;
        },
        methods: {
            init: function () {
                let totalData = obj.copyObject(this.settleData);
                totalData.actualMoney = this.settleData.allTotalPrice;
                this.totalData = totalData;
                this.title = "确认";
                this.step = 1;

                //检查是否是充值类型订单
                let isRecharge = false;
                this.totalData.pro_data.forEach((val) => {
                    if(val.pro_type === 3) {
                        isRecharge = true;
                    }
                });
                if(!isRecharge)
                    this.payType.options.unshift({ label: "余额", value: 1});
            },
            //关闭窗口
            cancel: function () {
                this.storeUserMoney = false;
                this.$emit("state", false);
            },
            //确定结算
            settleTotal: function () {
                this.totalData.payType = this.payType.value;

                //判断是否需要输入支付密码
                if(this.totalData.payType == 1 && this.totalData.user_info.pay_password){
                    this.showPayPassword = true;
                }else
                    this.settlePost();
            },
            //结算请求
            settlePost: function () {
                if(this.loading) return false;
                this.loading = true;

                this.showPayPassword = false;
                let postData = {
                    // order_date: this.totalData.order_date ? this.totalData.order_date : "",
                    order_no: this.totalData.order_no,
                    actual_money: this.totalData.actualMoney,
                    pay_type: this.totalData.payType,
                    store_uid: this.totalData.user_info.store_uid ? this.totalData.user_info.store_uid : "",
                    pay_password: this.totalData.pay_password ? this.totalData.pay_password : "",
                    pro_data: JSON.stringify(this.totalData.pro_data),
                    remark: this.totalData.remark,
                    give_data: this.totalData.give_data,
                };
                let url = "cash/settle";
                obj.postData(url, postData, res => {
                    if(res.errcode === 0) {
                        this.ticketData = res.ticket_data;
                        this.storeUserMoney = res.store_user_money;
                        this.settleOver();
                    }else
                        obj.message.error(res.errdesc);

                    this.loading = false;
                }, res => {
                    this.loading = false;
                });
            },
            //付款结束
            settleOver: function () {
                this.title = "结算成功";
                this.step = 2;
                this.showBack = false;
                this.overData = {
                    totalPrice: this.totalData.actualMoney,
                    is_print: false
                };
            },
            //付款所有流程结束
            settleAllOver: function () {
                this.cancel();
                this.$emit("settleOver");
            },
            //keypress
            keypressEvent: function (e) {
                if(e.code === "Enter"){
                    if(this.step === 1){
                        this.settleTotal();
                    }else if(this.step === 2){
                        this.settleAllOver();
                    }
                }
            },
        },
        watch: {
            isShow: function (newData) {
                if(newData)
                    this.init();
            },
            showPayPassword: function (d) {
                if(d){
                    this.$nextTick( () => {
                        this.$refs.passwordInput.focus();
                    });
                }
            },
            isBack: function (data) {
                this.showBack = data;
            },
            loading: function (val) {
                if(val){
                    this.loadDom = this.$loading({
                        lock: false,
                        // text: 'Loading',
                        // spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.3)',
                        target: ".container"
                    });
                }else{
                    this.loadDom.close();
                }
            }
        }
    }
</script>

<style scoped>
    .form-box{
        text-align: left;
    }
    .back{
        font-weight: bold;
    }
    .body-box{
        padding-right: 10px;
        height: 280px;
    }
    .password-box{
        z-index: 999;
    }
    .total-price{
        color: #7ed321;
        font-size: 28px;
        text-align: center;
        padding-top: 10px;
    }
    .success-icon{
        color: #7ed321;
        font-size: 80px;
        text-align: center;
        padding-top: 40px;
    }
    .print-box{
        text-align: center;
        padding-top: 30px;
    }
    .user-money{
        text-align: center;
        padding-top: 10px;
    }
</style>
